import { Col, Form, Row } from "react-bootstrap";
import { ClientGeneralParams } from "../../types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
import '../GeneralParams.css'

interface PromptingParamsProp {
    updateField: (field: keyof ClientGeneralParams, value: any) => void
}

export default function PromptingParams({ updateField }: PromptingParamsProp) {
    const { t } = useTranslation(['clientParams']);
    const clientParams = useSelector((state: RootState) => state.clientParamsForm.data);
    const errors = useSelector((state: RootState) => state.clientParamsForm.errors);

    return (
        <Form>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.sentimentValueLabel")}</Form.Label>
                <Col md={3}>
                    <Form.Label className="form-sublabel">{t("common:minimumValue")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.sentimentMinimumValue ?? ""}
                        onChange={(e) => updateField("sentimentMinimumValue", e.target.value)}
                        isInvalid={!!errors?.sentimentMinimumValue}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.sentimentMinimumValue}
                    </Form.Control.Feedback>
                </Col>
                <Col md={3}>
                    <Form.Label className="form-sublabel">{t("common:maximumValue")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.sentimentMaximumValue ?? ""}
                        onChange={(e) => updateField("sentimentMaximumValue", e.target.value)}
                        isInvalid={!!errors?.sentimentMaximumValue}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.sentimentMaximumValue}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.alertValueLabel")}</Form.Label>
                <Col md={3}>
                    <Form.Label className="form-sublabel">{t("common:minimumValue")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.alertMinimumValue ?? ""}
                        onChange={(e) => updateField("alertMinimumValue", e.target.value)}
                        isInvalid={!!errors?.alertMinimumValue}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.alertMinimumValue}
                    </Form.Control.Feedback>
                </Col>
                <Col md={3}>
                    <Form.Label className="form-sublabel">{t("common:maximumValue")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.alertMaximumValue ?? ""}
                        onChange={(e) => updateField("alertMaximumValue", e.target.value)}
                        isInvalid={!!errors?.alertMaximumValue}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.alertMaximumValue}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column md={6}>{t("clientParams:form.commentAlertValueLabel")}</Form.Label>
                <Col md={3}>
                    <Form.Label className="form-sublabel">{t("common:minimumValue")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.commentAlertMinimumValue ?? ""}
                        onChange={(e) => updateField("commentAlertMinimumValue", e.target.value)}
                        isInvalid={!!errors?.commentAlertMinimumValue}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.commentAlertMinimumValue}
                    </Form.Control.Feedback>
                </Col>
                <Col md={3}>
                    <Form.Label className="form-sublabel">{t("common:maximumValue")}</Form.Label>
                    <Form.Control
                        type="number"
                        value={clientParams.commentAlertMaximumValue ?? ""}
                        onChange={(e) => updateField("commentAlertMaximumValue", e.target.value)}
                        isInvalid={!!errors?.commentAlertMaximumValue}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors?.commentAlertMaximumValue}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
        </Form>
    );
}